import { supabase } from '../lib/supabase';

export const userService = {
  async getAllContributors() {
    try {
      const { data, error } = await supabase?.from('user_profiles')?.select('*')?.order('created_at', { ascending: false });

      if (error) throw error;

      return data?.map(profile => ({
        id: profile?.id,
        name: profile?.full_name,
        email: profile?.email,
        role: profile?.role,
        avatar: profile?.avatar_url,
        isActive: profile?.is_active,
        createdAt: profile?.created_at,
        updatedAt: profile?.updated_at
      })) || [];
    } catch (error) {
      console.error('Error fetching contributors:', error);
      throw error;
    }
  },

  async updateUserRole(userId, newRole) {
    try {
      const { data, error } = await supabase?.from('user_profiles')?.update({ role: newRole })?.eq('id', userId)?.select()?.single();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error updating user role:', error);
      throw error;
    }
  },

  async createOwner(email) {
    try {
      // Check if user already exists
      const { data: existingUser, error: checkError } = await supabase?.from('user_profiles')?.select('id, role')?.eq('email', email)?.single();

      if (existingUser) {
        // User exists, update role to owner
        return await this.updateUserRole(existingUser?.id, 'owner');
      }

      // For new users, they need to sign up first
      // This function just marks existing users as owners
      throw new Error('User must sign up first before being assigned as owner');
    } catch (error) {
      console.error('Error creating owner:', error);
      throw error;
    }
  },

  async toggleUserStatus(userId, isActive) {
    try {
      const { data, error } = await supabase?.from('user_profiles')?.update({ is_active: isActive })?.eq('id', userId)?.select()?.single();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error toggling user status:', error);
      throw error;
    }
  }
};
